import PubSub from 'pubsub-js';
import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';

const stripOfLogos = {
  init() {
    this.$sections = document.querySelectorAll('section.strip_of_logos');
    this.swipers = [];

    if (this.$sections && this.$sections.length) {
      this.destroyBinded = this.destroy.bind(this);
      this.resizeHandlerBinded = this.resizeHandler.bind(this);
      this.setUpListeners();
      this.setUpCarousel();
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);
    window.addEventListener('resize', this.resizeHandlerBinded);
  },

  lastWidth: window.innerWidth,
  resizeTimeout: null,
  resizeHandler() {
    if (this.lastWidth !== window.innerWidth) {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.destroyCarousel();
        this.setUpCarousel();
      }, 300);
    }
  },

  setUpCarousel() {
    console.log('Logo strip module found. Init carousel');

    this.$sections.forEach($section => {
      this.swipers.push(new Swiper($section.querySelector('.swiper'), {
        modules: [Pagination, Autoplay, EffectFade],
        slidesPerView: 2,
        slidesPerGroup: 2,
        // centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        breakpoints: {
          // when window width is >= 320px
          767: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        }
      }));
    });
  },

  destroyCarousel() {
    this.swipers.forEach(swiper => {

      swiper.destroy();
    });
  },

  destroy() {
    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
    window.removeEventListener('resize', this.resizeHandlerBinded);
    this.destroyCarousel();
  }
};

PubSub.subscribe('page.inDOM', stripOfLogos.init.bind(stripOfLogos));

export default stripOfLogos;
